var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCameraSlash = function SvgIconCameraSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.88 1.578A1 1 0 0 0 2.4 2.922l1.896 2.086A2.5 2.5 0 0 0 2 7.5V18a2.5 2.5 0 0 0 2.5 2.5h13.872l1.747 1.922a1 1 0 0 0 1.48-1.344l-2.021-2.226-.045-.048zM16.556 18.5l-2.215-2.438a4.375 4.375 0 0 1-5.79-6.371L6.106 7H4.5a.5.5 0 0 0-.5.5V18a.5.5 0 0 0 .5.5zm-6.618-7.283 3.016 3.319-.021.009a2.376 2.376 0 0 1-3.005-3.31z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.572 2.75a1 1 0 1 0 0 2h4.893l1.203 1.805A1 1 0 0 0 16.5 7h3a.5.5 0 0 1 .5.5v8.822a1 1 0 1 0 2 0V7.5A2.5 2.5 0 0 0 19.5 5h-2.464l-1.204-1.805A1 1 0 0 0 15 2.75z"
  }))));
};
export default SvgIconCameraSlash;